import type { MutableRefObject } from 'react';
import { useRef } from 'react';

import { type RootState, useAppSelector } from '@/redux/store';

const useSelectorRef = <T = unknown>(
  selectHandler: (state: RootState) => T,
): MutableRefObject<T> => {
  const ref = useRef<T>();

  useAppSelector<T>(selectHandler, (_, b) => {
    ref.current = b;

    return true;
  });

  return ref as MutableRefObject<T>;
};

export { useSelectorRef };
